<template>
  <span v-if="$slots.default" :class="errorMessageClasses">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    errorMessageClasses: {
      type: [String, Array, Object],
      default: 'text-[1rem] text-[#B80A0A] leading-[1.5rem] mt-[4px]',
    },
  },
};
</script>
